'use client';

import { OddsModel, SportMatchModel } from '@nf/types/odds';
import { MatchLiveTimer } from './top-bar-match-live-timer';
import { MatchTeamName } from './top-bar-match-team-name';
import { MatchLiveStreaming } from './top-bar-match-live-streaming';
import { MatchLiveScore } from './top-bar-match-live-score';
import { useRouter } from '@/navigation';
import { usePathname } from 'next/navigation';
import { useStreamingStore } from '@/store/streaming';
import { matchEquals } from '@nf/utils-common/fpw/monadic';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { KafkaNote } from '@nf/utils-common/constants';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { useAnalyseAttribute } from '@/features/next-analyse';

interface TopbarMatchListOptionProps {
	matchId?: number;
	oddsData: OddsModel | null;
	matchList: SportMatchModel[];
}

export const TopbarMatchListOption = ({ matchId, oddsData, matchList }: TopbarMatchListOptionProps) => {
	const [
		setStreamingStatus,
		setIsStreamingFloat
	] = useStreamingStore(state => [
		state.setStreamingStatus,
		state.setIsStreamingFloat
	]);
	const pathName = usePathname();
	const router = useRouter();
	const view = useAppearanceStore(state => state.view);
	const taggedElement = useAnalyseAttribute('switch-to-single-match-via-match-dropdown');
	
	const redirectToOtherMatch = (matchId: number) => {
		setKafka();
		const singleMatchHref = matchEquals(pathName.split('/').slice(1, 2).join('/'))
			.on('sports', () => `${pathName.split('/').slice(0, -1).join('/')}/${matchId}`)
			.on('live', () => `${pathName.split('/').slice(0, -1).join('/')}/${matchId}`)
			.otherwise(() => `/${pathName.split('/').slice(2, -1).join('/')}/${matchId}`);
		setStreamingStatus('', '', []);
		setIsStreamingFloat(false);
		router.push(singleMatchHref);
	};

	const setKafka = () => {
		const isGalaxy = view === ViewEnum.galaxy;
		const isShowRightMenu = window.innerWidth >= 1250;

		if (isGalaxy) {
			const kafkaData = {
				note: KafkaNote.GalaxyV2,
				type: 9,
				action: isShowRightMenu ? 9 : 2
			}
			setKafkaNormal(kafkaData);
		} else {
			const kafkaData = {
				note: KafkaNote.MarsV1,
				type: 6,
				action: isShowRightMenu ? 33 : 31
			}
			setKafkaNormal(kafkaData);
		}
	}

	return (
		<>
			{
				matchList.map((match, index) => {
					return (
						<div
							className="select-match-item"
							key={index}
							data-active={match.MatchId === matchId}
							onClick={() => {
								redirectToOtherMatch(match.MatchId)
							}}
							ref={taggedElement}
						>
							<MatchLiveTimer match={match} />
							<MatchTeamName oddsData={oddsData} match={match} />
							<MatchLiveStreaming match={match} />
							<MatchLiveScore match={match} />
						</div>
					)
				})
			}
		</>
	)
}

